import React,{useEffect,useState} from 'react';
import { useParams } from 'react-router-dom';
import { API } from '../api';
import { defaultProductPicture } from '../imageUtils';

export default function Verify(){
 const {id}=useParams();
 const [d,setD]=useState(null);

 useEffect(()=>{
  fetch(`${API}/verify/${id}`).then(r=>r.json()).then(setD);
 },[id]);

 if(!d)return <div className="container">Loading...</div>;

 return <div className="container">
  <h2>{d.valid?'Verified':'Tampered'}</h2>
  <img className="productImageLarge" src={d.receipt.product_picture || defaultProductPicture} alt="" />
  <p>{d.receipt.product_name}</p>
  {d.receipt.product_reference && <p>{d.receipt.product_reference}</p>}
  <p>{d.receipt.quantity} {d.receipt.unit_name}</p>
  <div className="ledgerPanel">
    <h3>Ledger</h3>
    {d.ledger ? (
      <>
        <p><b>Status:</b> {d.ledger.valid ? 'Signed and linked' : 'Ledger issue detected'}</p>
        <p><b>Sequence:</b> {d.ledger.entry.sequence_number}</p>
        <p><b>Entry hash:</b></p>
        <p className="hashText">{d.ledger.entry.entry_hash}</p>
        <p><b>Previous hash:</b></p>
        <p className="hashText">{d.ledger.entry.previous_hash}</p>
        <ul className="ledgerChecks">
          <li>Payload hash: {d.ledger.checks.payloadHashValid ? 'valid' : 'invalid'}</li>
          <li>Previous link: {d.ledger.checks.previousHashValid ? 'valid' : 'invalid'}</li>
          <li>Entry hash: {d.ledger.checks.entryHashValid ? 'valid' : 'invalid'}</li>
          <li>Signature: {d.ledger.checks.signatureValid ? 'valid' : 'invalid'}</li>
        </ul>
      </>
    ) : (
      <p>No ledger entry for this receipt.</p>
    )}
  </div>
  <a href={`${API}/receipt/${id}/pdf`} target="_blank" rel="noreferrer">Print</a>
 </div>;
}
